import { render } from "./LatestComment.vue?vue&type=template&id=051ad89a"
import script from "./LatestComment.vue?vue&type=script&lang=js"
export * from "./LatestComment.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__